import { render, staticRenderFns } from "./BaseDetailTableFiltered.vue?vue&type=template&id=27ae4550&scoped=true"
import script from "./BaseDetailTableFiltered.vue?vue&type=script&lang=js"
export * from "./BaseDetailTableFiltered.vue?vue&type=script&lang=js"
import style0 from "./BaseDetailTableFiltered.vue?vue&type=style&index=0&id=27ae4550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ae4550",
  null
  
)

/* custom blocks */
import block0 from "./BaseDetailTableFiltered.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports